import type { ChatState, SettingsState } from './interfaces';

export function settingsReducer(state: SettingsState.State, action: ChatState.Action): SettingsState.State {

  switch (action.type) {
    case 'default-context-updated': {
      const { defaultContext } = action.payload;
      return {
        ...state,
        defaultContext,
      };
    }

    default:
      return state;
  }
}